/* Important Info component for the Character page */
import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../styles/Callsheets.module.css";

const InfoChar = () => {
  return (
    <div className="mb-5">
        <Row >
        <Col md={{span: 8, offset: 2}}>
        <div className={`px-3 pt-1 pb-2 ${styles.SubTitle6 }`}>
        <h5 className={`text-center ${styles.Red }`} >INFO</h5>  
        <hr className={`mt-2 mb-0`}/>
        <p className={`pt-2 text-center`}>
         <span className={`${styles.Red}`}>*</span> When <span className={`${styles.Red}`}>registering</span> the Actor use the 3 Dots Edit icon to open the Edit page and add 
        their details.
          </p>
          <hr className={`mt-2 mb-0`}/>
         </div> 
        </Col>
      </Row>
    </div>
  )
}

export default InfoChar